module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/banistmo_panama.11988961.svg";